import React from 'react';

import SettingsIcon from '@atlaskit/icon/core/settings';

import { CreateSpaceButton } from '@confluence/create-space/entry-points/createSpace';

export const HTV2CreateSpaceCTA = ({ onClick }: { onClick: () => void }) => {
	return (
		<CreateSpaceButton
			onClick={onClick}
			source="home-onboarding-takeover-v2"
			appearance="default"
			icon={<SettingsIcon label="" />}
		/>
	);
};
